import React, { useEffect } from "react";
import styled from "styled-components";
import "react-spring-bottom-sheet/dist/style.css";

const ProfilePic = styled.img`
  border-radius: 50%;
  border: 0px solid #ffffff;
  height: 36px;
  width: 36px;
  z-index: 1;
`;

export default function ProfileIcon(props) {
  return (    
    <ProfilePic src={props.img}></ProfilePic>      
  );
}
